import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

// non aborting router change methods

export const useSafeRouter = () => {
  const [onChanging, setOnChanging] = useState(false)
  const handleRouteChange = () => {
    setOnChanging(false)
  }
  const router = useRouter()

  const safeReplace = (path: any) => {
    if (onChanging) {
      return
    }
    setOnChanging(true)
    router.replace(path)
  }

  const safePush = (path: any) => {
    if (onChanging) {
      return
    }
    setOnChanging(true)
    router.push(path)
  }

  useEffect(() => {
    router.events.on('routeChangeComplete', handleRouteChange)

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [router, setOnChanging])
  return { safeReplace, safePush }
}
